import { Flow } from 'signup-constants/Flow';
import { isFlow } from '../utils/isFlow';
import { isExistingUserExistingAccount } from '../app/verificationTypeSelectors';
import { getIsAuthenticated } from '../store/auth/selectors';
import { isEndOfFlow } from '../store/flow/selectors';
import { hasPostSignupBeenSubmitted } from '../store/http-responses/selectors';
import { hasAnsweredAllPostExistingAccountSelectedQuestions } from '../store/signup-data/selectors';
export const canRedirectExistingUserExistingAccount = state => {
  return isEndOfFlow(state) && getIsAuthenticated(state) && hasPostSignupBeenSubmitted(state) && hasAnsweredAllPostExistingAccountSelectedQuestions(state) && isExistingUserExistingAccount(state) && !isFlow(Flow.StandaloneCmsPartner);
};